// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__3vt_Z","spinAround":"Divider_spinAround__mqQuR"};